export function setSync(state, value) {
  state.sync.push({
    ...value,
    synced: false,
    historico: Array.from(state.historico)
  })
}
